import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import { Info } from 'lucide-react';

import {
  CAMPAIGN_ANALYSIS_REPORT_USAGE_INFO,
  getCampaignAnalysisReportUsageLabel,
  type CampaignAnalysisReportUsage,
} from '../helpers/analysis-report-usage';

export function CampaignAnalysisReportUsageIndicator({
  usage,
}: {
  usage: CampaignAnalysisReportUsage;
}) {
  const tooltipContent = CAMPAIGN_ANALYSIS_REPORT_USAGE_INFO(usage.limit);

  return (
    <div className="flex items-center gap-1.5 whitespace-nowrap">
      <span className="text-foreground text-sm font-semibold">
        {getCampaignAnalysisReportUsageLabel(usage)}
      </span>
      <TooltipFlat asChild content={tooltipContent} contentClassName="max-w-72 text-sm leading-5">
        <button
          aria-label="Monthly report usage info"
          className="text-muted-foreground hover:text-foreground transition-colors"
          type="button"
        >
          <Info aria-hidden="true" className="size-4" />
        </button>
      </TooltipFlat>
    </div>
  );
}
